import { hubbleAPI } from './url'
export default ($axios) => ({
  getChildSubscriptionsForFamilySubscription(parentSubscriptionId) {
    return $axios.get(`${hubbleAPI}public/ct/family-concept/child-subscriptions/${parentSubscriptionId}`)
  }
})
